import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

const TermsConditionsModal = ({ isOpen, onClose, toggleModal }) => {
  if (!isOpen) return null;
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="overflow-y-scroll sm:overflow-y-hidden"
    >
      <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
        <div className="w-full sm:w-148 flex-grow">
          <div className="sm:w-full bg-white rounded-xl sm:mt-14">
            <div className="grid grid-cols-1 divide-y">
              <div className="p-4">
                <div className="grid justify-items-end">
                  <CloseIcon
                    className="cursor-pointer absolute"
                    onClick={onClose}
                    sx={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>
                <div className=" font-bold text-center ">
                  Terms and Conditions
                </div>
              </div>

              <div>
                <div className="sm:h-96 overflow-y-scroll">
                  <div className="w-full p-4">
                    <div className="text-center font-bold text-sm">
                      MAXICARE eHEALTH
                    </div>

                    <div className="text-center font-bold text-sm">
                      TERMS AND CONDITIONS FOR MEMBERS
                    </div>

                    <div className="mt-2 text-xs">
                      VERSION AS OF: April 11, 2024
                    </div>

                    <div className="mt-2">
                      <div className="text-xs text-justify">
                        The Maxicare Electronic Healthcare Program (“{/* */}
                        <span className="font-bold">eHealth</span>”)
                        collectively refers to the technology-based,
                        innovation-driven, and/or virtually-delivered wellness
                        products, services, and solutions of Maxicare Healthcare
                        Corporation (“{/* */}
                        <span className="font-bold">Maxicare</span>”), such as
                        but not limited to, telemedicine or teleconsultation,
                        wellness webinars, nutrition counseling, health
                        monitoring applications and other home-based virtual
                        services & automated solutions, among others, which are
                        part of Maxicare’s effort to ensure care continuity and
                        help establish value based healthcare for its members.
                        You, the User-Member, (“{/* */}
                        <span className="font-bold">User/Member</span>”) agree
                        to support and use eHealth in availing services and
                        healthcare solutions from Maxicare and its healthcare
                        providers (the “{/* */}
                        <span className="font-bold">Services</span>”) and agree
                        for Maxicare to enroll you in its eHealth systems and as
                        they come online.
                      </div>

                      <div className="mt-2 text-xs text-justify">
                        The Maxicare eHealth Program primarily consists of the
                        following Services: (1) a Health Questionnaire which
                        shall determine your baseline medical condition, (2) a
                        software program and platform (“{/* */}
                        <span className="font-bold">App</span>”) developed by
                        Maxicare or other third party developers (“{/* */}
                        <span className="font-bold">Third-Party Owner</span>”)
                        of which Maxicare has ownership, and/or relevant and
                        necessary access and authorization, (3) specialized
                        activities which includes but not limited to: (a) access
                        to medical devices as may be determined by Maxicare, (b)
                        online webinars, lectures and fitness sessions, (c)
                        nutrition and emotional counseling, (d) instructional
                        cooking videos and recipes, (4) Telemedicine and/or
                        Teleconsultation services, and (5) other wellness
                        related activities which Maxicare may formulate or
                        endorse from time to time. These services and/or
                        activities may include data collection, browser
                        interface, data encryption, transmission, access and
                        storage that allows Maxicare to provide you with health
                        services and verify required personal information and
                        the Member to request and receive authorizations, among
                        others. Some or a combination of these Services may be
                        prescribed to you, based on your medical condition and
                        the availability of slots for said Services and/or
                        activities, as may be solely determined by Maxicare.
                      </div>

                      <div className="mt-2 text-xs text-justify">
                        These Terms and Conditions (“T&Cs”) are intended to
                        govern the participation, access, and use by Members of
                        the Services under eHealth, and shall form part of the
                        agreements with Maxicare and its Representatives, as
                        defined below. Please review these Terms and Conditions
                        carefully and indicate your agreement by clicking on the
                        corresponding box towards the end of this document.
                        Maxicare reserves the right to modify these Terms and
                        Conditions from time to time without need of prior
                        notice or approval. Members may access the latest
                        version at{" "}
                        <a
                          href="https://maxicare.com.ph/ehealth-members"
                          target="_blank"
                          rel="noreferrer"
                          className="text-[#0947AB] font-semibold"
                        >
                          https://maxicare.com.ph/ehealth-members
                        </a>
                        , and any queries related thereto may be addressed to{" "}
                        <a
                          href="mailto:dpo@maxicare.com.ph"
                          target="_blank"
                          rel="noreferrer"
                          className="text-[#0947AB] font-semibold"
                        >
                          dpo@maxicare.com.ph
                        </a>
                        {/* */}.
                      </div>

                      <div className="mt-2 text-xs text-justify">
                        By participating in, accessing, and/or using any of the
                        Services, Apps and/or activities eHealth, you
                        acknowledge and agree to abide by all the terms and
                        conditions contained herein, and in any other relevant
                        agreement (the{" "}
                        <span className="font-bold">“Agreements”</span>)
                        executed between you or your Company (or Employer), and
                        Maxicare, including but not limited to, the privacy and
                        security policies, including any materials available in
                        the App, medical and handling protocols, and reporting
                        rules, which are hereby incorporated by reference,
                        subject to changes and notices by Maxicare. Your
                        signature may no longer be required to manifest your
                        consent herein. All other provisions of the Agreements
                        which are not inconsistent to these Terms and Conditions
                        are deemed applicable and incorporated. In case any
                        conflict arises between the provisions of the Agreements
                        and these Terms and Conditions, the Terms and Conditions
                        shall govern in so far as the conflict involves Maxicare
                        eHealth.
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="text-xs font-bold">
                        1. Representations & Warranties
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">a.</span> The User/Member
                        guarantees that all information provided to Maxicare
                        through any of the Services and/or activities under
                        eHealth is true and correct and shall ensure that the
                        personal information and contact details submitted via
                        the Services and/or activities under eHealth are
                        accurate and kept up to date. Non-disclosure or
                        falsification of information shall be a ground for
                        termination of the Agreement, without prejudice to any
                        other legal remedies that may be available to Maxicare.
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">b.</span> The User/Member
                        agrees and understands that all his/her representations,
                        warranties and undertakings shall be deemed to be
                        material and have been relied upon by Maxicare.
                        Consequently, the User/Member shall be directly and
                        solely responsible for the accuracy and truthfulness of
                        any and all information submitted via the Services
                        and/or activities under eHealth. They shall survive the
                        execution and delivery of these T&Cs, notwithstanding
                        the consummation of the transaction contemplated herein.
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">c.</span> The User/Member
                        agrees and understands that in the course of providing
                        the Services and/or activities under eHealth to the
                        Member, and in enhancing, developing and further
                        improving or augmenting the Services and/or activities
                        under eHealth, Maxicare and/or the Company shall engage
                        the services of, procure goods and services from,
                        collaborate and/or interact with, other third parties,
                        such as, but not limited to their respective parent
                        company, affiliated companies, subsidiaries, financial
                        advisors, affiliated third parties and service providers
                        or independent/non-affiliated third parties, and service
                        providers, whether local or foreign, (collectively
                        referred to as{/* */}
                        <span className="font-bold"> "Representatives"</span>).
                      </div>

                      <div>
                        <div className="text-xs mt-2 text-justify ml-4">
                          <span className="font-bold">d.</span> The User/Member
                          agrees to freely, knowingly and voluntarily give
                          his/her consent, in accordance with Republic Act No.
                          10173, otherwise known as the Data Privacy Act of
                          2012, including its Implementing Rules and Regulations
                          and other issuances of the National Privacy Commission
                          (collectively, the{" "}
                          <span className="font-bold">“Data Privacy Laws”</span>
                          {/* */}
                          ), to Maxicare. the Company and their respective
                          stockholders, directors, officers, employees, agents,
                          brokers ({/* */}
                          <span className="font-bold">
                            “Authorized Personnel”
                          </span>
                          {/* */}) and/or Representatives, to:
                        </div>

                        <div className="text-xs mt-2 text-justify ml-10">
                          <span className="font-bold">i.</span> Obtain, examine,
                          process, collect, record, organize, store, update or
                          modify, retrieve, consult, use, consolidate, block,
                          erase, destroy or do any operation or set of
                          operations (collectively “process” / “processing”) the
                          User/Member’s and his Dependent/s’ personal
                          information, including sensitive personal information
                          and privileged information, Maxicare Card Number,
                          medical records (including ACU/ECU results and
                          Maxicare card utilization records), or any other
                          information or material, i.e., picture, video and
                          voice recording, fingerprints, CCTV or any other item,
                          artifact, element or specimen that would be utilized
                          for identification and verification, (collectively
                          “Personal Data”) relative to the User/Member and his
                          Dependents’ application and membership with Maxicare,
                          availment of the Services and/or activities under
                          eHealth , hospitalization, consultation, and treatment
                          or any medical advice in connection with the
                          benefit/claim availed under the Agreement, as may be
                          deemed necessary by Maxicare. Except as otherwise
                          stated in these T&Cs, any personal data obtained
                          relative to the authority herein given shall be kept
                          strictly confidential. The extent of the processing of
                          the Personal Data shall be limited to what is
                          necessary, appropriate or incidental to the
                          performance of the Services and eHealth as
                          contemplated in the Agreement and these T&Cs.
                        </div>

                        <div className="text-xs mt-2 text-justify ml-10">
                          <span className="font-bold">ii.</span> Process and
                          disclose such Personal Data to Maxicare and its
                          Representatives, the Company, and their Authorized
                          Personnel as well as relevant government agencies in
                          compliance with the Republic Act No. 11223 otherwise
                          known as the “Universal Health Care Act”, its
                          Implementing Rules and Regulations, Republic Act No.
                          11332 otherwise known as the “Mandatory Reporting of
                          Notifiable Diseases and Health Events of Public Health
                          Concern Act” and other relevant issuances of the
                          Department of Health and/or Philippine Health
                          Insurance Corporation, and any amendments to such
                          laws, rules, regulations and issuances for any
                          legitimate business purpose as Maxicare may deem
                          appropriate, including but not limited to outsourced
                          processing of Maxicare transactions, billing of co-pay
                          arrangements or Administrative Services Only (ASO),
                          lifestyle and rewards partners/providers, profiling or
                          historical statistical analysis, providing advice or
                          information which Maxicare, its Representatives and
                          their Authorized Personnel believe may be of interest
                          to the User/Member or the Company, to effectively
                          administer or manage my account, enhance customer
                          services, or to communicate with such User/Member for
                          any marketing purposes.
                        </div>
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        For clarity, processing would include both manual and
                        automated handling, storage and transfer of personal
                        data using various means and methods whether physical or
                        electronic (via information and communications systems
                        employed by Maxicare and its Representatives).
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">e.</span> The Processing
                        contemplated in these T&Cs shall be without prejudice
                        to, and shall at all times take into account and uphold
                        the rights of User/Member as a Data Subject, as provided
                        under the Data Privacy Laws, such as but not limited to
                        the right to be informed, to object, access, complain,
                        and rectify, to request for filtering of certain
                        information, and to the corresponding damages in case of
                        violation of your rights within the corresponding
                        limitations as set forth in the Data Privacy Laws.
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">f.</span> The User/Member
                        hereby provides his unconditional consent to the matters
                        specified herein; and Maxicare shall have all the right
                        to rely on such consent, including the representation by
                        the User/Member that this consent shall have been duly
                        and timely obtained prior to use of the App.
                      </div>

                      <div className="text-xs mt-2 text-justify ml-4">
                        <span className="font-bold">g.</span> The User/Member
                        may be able to connect with Third Party through the
                        Platform, but this does not mean Maxicare endorses,
                        monitors or has any control over these Third Parties or
                        their activities, which are subject to separate terms of
                        use and privacy policies. You should carefully review
                        any Third Party’s sites and terms of use and privacy
                        policy.{" "}
                        <span className="font-bold">
                          Maxicare is not responsible for the content, policies,
                          or activities of Third Parties and you interact with
                          Third Parties at your own risk.
                        </span>
                      </div>
                    </div>

                    <div className="mt-2">
                      <div className="text-xs font-bold">
                        2. Specific Activities
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold text-xs">a. </span> The
                        User/Member, if qualified based on his medical
                        condition, based on the sole discretion of Maxicare,
                        will have access to additional Services and/or
                        activities under eHealth targeted to help his/her
                        medical condition, one of which is a health monitoring
                        device. Said device will be lent to him/ her for a
                        specified period as part of his/her medical management.
                        The use of the aforementioned health monitoring device
                        will be for the exclusive use of the specific Maxicare
                        User/Member to whom it is lent and which is the
                        responsibility of the User/ Member while in his/her
                        possession. The User/Member will also be responsible for
                        the purchase of the additional consumables or supplies
                        that have not been provided by Maxicare. The User/Member
                        agrees to return the health monitoring device at the end
                        of the lending period in the same condition that it was
                        on the day it was received, except for the normal wear
                        and tear associated with its normal use. If the device
                        is lost or damaged while in the User/Member’s
                        possession, it is the User/Member’s responsibility to
                        have it repaired or replaced within thirty (30) days
                        from reporting the incident to Maxicare. For inquiries
                        on Freestyle Libre, members can contact Maxicare’s
                        partner at adc-cs.ph@abbott.com or (02) 87028577 ( M-F
                        9-6PM).
                      </div>

                      <div>
                        <div className="text-xs text-justify ml-4 mt-2">
                          <span className="font-bold text-xs">b. </span> For
                          Telemedicine or Teleconsultation services:
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold text-xs">i. </span> The
                          services received from Maxicare’s accredited physician
                          are not intended to replace a primary care physician
                          relationship. The User/Member should seek emergency
                          help or follow-up care when recommended by the
                          Maxicare’s accredited physician or when otherwise
                          needed, and continue to consult with his primary care
                          physician and other health care professionals as
                          recommended. Anticipated benefits may be expected but
                          no results can be guaranteed or assured. Maxicare’s
                          accredited physician, in his/her sole discretion and
                          professional judgment, may determine that Telemedicine
                          or Teleconsultation services are not appropriate for
                          some or all of the User/Member’s treatment needs and,
                          accordingly, may elect not to provide Telemedicine or
                          Teleconsultation services to a User/Member.
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold text-xs">ii. </span>{" "}
                          Maxicare makes no representations or warranties,
                          express or implied, with respect to the health advice
                          to be provided by the Maxicare’s accredited physician.
                          It does not warrant the reliability, accuracy,
                          timeliness, usefulness, adequacy, completeness or
                          suitability of the advice provided. Furthermore, it
                          does not guarantee that a video and/or telephone
                          consultation is the appropriate course of treatment
                          for the User/Member’s particular health care problem.
                          The User/Member hereby agrees to contact his/her
                          primary care physician immediately should his/her
                          condition change or symptoms worsen.
                        </div>

                        <div>
                          <div className="text-xs text-justify ml-10 mt-2">
                            <span className="font-bold text-xs">iii. </span>{" "}
                            Potential Risks: It is hereby understood that the
                            following risks are associated with Telemedicine or
                            Teleconsultation services:
                          </div>

                          <div className="text-xs ml-14 mt-1 text-justify">
                            ● The information provided by User/Member may be
                            insufficient to enable the Maxicare’s accredited
                            physician to provide appropriate medical or health
                            care advice;
                          </div>

                          <div className="text-xs ml-14 mt-1 text-justify">
                            ● There may be delays in evaluation due to failure
                            of the electronic equipment;
                          </div>

                          <div className="text-xs ml-14 mt-1 text-justify">
                            ● The lack of access to all the User/Member’s
                            medical records may result in adverse drug reactions
                            or allergic reactions or other judgment errors; and
                          </div>
                          <div className="text-xs ml-14 mt-1 text-justify">
                            ● There may be symptoms and ailments that may not be
                            completely diagnosed except through actual physical
                            examination or observation of demeanor which may
                            cause misdiagnosis or errors in treatment.
                          </div>
                        </div>
                      </div>

                      <div className="mt-2">
                        <div className="text-xs font-bold">3. Terms of Use</div>

                        <div className="text-xs text-justify ml-4 mt-2">
                          <span className="font-bold">a. </span>{" "}
                          <span className="font-bold italic">
                            Privacy & Security Policies.
                          </span>{" "}
                          The use of the Services and/or activities under
                          eHealth shall be governed by such privacy and security
                          policies which are adopted by Maxicare and the
                          Third-Party Owner from time to time, whether such
                          privacy and security policies are contained in the
                          activities, Services or the App, in the agreements
                          and/or respective websites. Maxicare and the
                          Third-Party Owner reserve the right to modify, alter
                          or amend the privacy and security policies without
                          need of prior notice or approval of the User/Member.
                        </div>

                        <div className="text-xs text-justify ml-4 mt-2">
                          <span className="font-bold">b. </span>{" "}
                          <span className="font-bold italic">
                            User/Member Information and Data.
                          </span>{" "}
                          The User/Member shall be directly and solely
                          responsible for the accuracy, quality, integrity,
                          legality, reliability and/or appropriateness of all
                          the data, information or material that it will submit
                          to the Services and/or activities under eHealth,
                          including Personal Data, (the{" "}
                          <span className="font-bold">"User/Member Data"</span>
                          {/* */}). In this regard, it is understood that
                          Maxicare and the Third-Party Owner shall not be
                          responsible or liable for the deletion, correction,
                          destruction, damage, loss or failure to store any of
                          the User/Member's Data arising from the use of the
                          Services and/or activities under eHealth. Maxicare and
                          the Third-Party Owner further reserve the right to
                          withhold, remove and/or discard User/Member's Data
                          without need of notice whatsoever to the User/Member
                          in case of breach of any of the terms hereof, the
                          Agreement, including non-payment of the relevant
                          fees/charges provided for herein. Upon termination for
                          cause, the User/Member’s right to access or use
                          User/Member's Data submitted to the Services and/or
                          activities under eHealth immediately ceases, and
                          Maxicare and the Third-Party Owner shall have no
                          obligation to maintain or forward any User/Member's
                          Data to the User/Member.
                        </div>

                        <div>
                          <div className="text-xs text-justify ml-4 mt-2">
                            <span className="font-bold">c. </span>{" "}
                            <span className="font-bold italic">
                              Security Breach.
                            </span>{" "}
                            When the User/Member knows or reasonably suspects
                            that an Information Security Breach has affected the
                            Personal Data or User/Member Data provided,
                            User/Member shall promptly notify Maxicare [in any
                            case within the later of 24 hours or one (1)
                            calendar day following such discovery] and cooperate
                            with Maxicare in any post-breach/incident
                            investigation, notification requirement, or
                            remediation efforts. The notification shall, at the
                            minimum, describe the nature of the breach or
                            incident, effects thereof, the Personal Data or
                            User/Member Data possibly involved, affected or
                            compromised; and the measures taken by the
                            User/Members to address the incident or remediate
                            the breach. It shall also include measures taken to
                            reduce the harm or negative consequences of the
                            breach or the security incident.
                          </div>

                          <div className="text-xs ml-10 mt-4">
                            User/Member may contact our Data Privacy Officer
                            thru the following contact details:
                          </div>

                          <div className="mt-2">
                            <div className="text-xs ml-10">
                              Data Protection Officer
                            </div>

                            <div className="text-xs ml-10">
                              Telephone no: (02) 8908-6989
                            </div>

                            <div className="text-xs ml-10">
                              Email address: dpo@maxicare.com.ph
                            </div>
                          </div>
                        </div>

                        <div className="text-xs text-justify ml-4 mt-4">
                          <span className="font-bold">d. </span>{" "}
                          <span className="font-bold italic">
                            Free and Harmless.
                          </span>{" "}
                          The User/Member shall hold Maxicare, the Third-Party
                          Owner and their Representatives and Authorized
                          Personnel free and harmless from and against any and
                          all suits or claims, actions, or proceedings, damages,
                          costs and expenses, including attorney’s fees, which
                          may be filed, charged or adjudged against said
                          entities and persons in connection with or arising
                          from the breach of these T&Cs by the User/Member or
                          the User/Member Account.
                        </div>

                        <div className="text-xs text-justify ml-4 mt-4">
                          <span className="font-bold">e. </span>{" "}
                          <span className="font-bold italic">
                            Other Related Programs subject to Opt-Out.
                          </span>{" "}
                          The consent herein granted by the User/Member upon
                          clicking on the “I agree” button and/or Services
                          and/or activities under eHealth, shall be understood
                          to include the agreement of the User/Member to be part
                          of or become a participant in any related health and
                          digital programs of Maxicare, now existing or
                          otherwise, provided such programs are related to,
                          connected with or in support of the Services, eHealth
                          or the App, including agreement to receive marketing
                          promotions through the contact details provided
                          herein, subject to the User/Member’s right to
                          hereinafter opt-out from any specific related program
                          as the User/Member may deem appropriate through the
                          opt-out links provided in a particular email, or via
                          the website providing such specific program, generally
                          found in{" "}
                          <a
                            className="text-[#0947AB] text-xs font-bold"
                            target="_blank"
                            rel="noreferrer"
                            href="https://forms.gle/Pmz73DWFba6R1ReMA"
                          >
                            https://forms.gle/Pmz73DWFba6R1ReMA
                          </a>
                        </div>
                      </div>

                      <div className="mt-2">
                        <div className="text-xs font-bold">
                          4. Disclaimer of Warranties
                        </div>
                      </div>

                      <div>
                        <div className="text-xs text-justify ml-4 mt-2">
                          <span className="font-bold">a. </span> Maxicare and
                          the Third-Party Owner, including their licensors, if
                          applicable, make no representation, warranty or
                          guarantee as to the reliability, timeliness, quality,
                          suitability, truth, availability, accuracy or
                          completeness of the Services and/or activities under
                          eHealth, and any if its features, functionalities,
                          interfaces, and services, or the contents thereof, and
                          likewise make no representation or warranty on the
                          following:
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">i. </span> that the use of
                          the Services and/or activities under eHealth, or any
                          of its features, functionalities, interfaces, and
                          services will be secured, timely, uninterrupted or
                          error-free or shall operate in combination with any
                          other hardware, software, system or date;
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">ii. </span> the Services
                          and/or activities under eHealth, and any of its
                          features, functionalities, interfaces, and services
                          will meet the User/Member’s requirements or
                          expectations;
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">iii. </span> any stored
                          data will be accurate or reliable;
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">iv. </span> the quality of
                          any products, services, information or other material
                          purchased or obtained by the User/Member through the
                          Services and/or activities under eHealth, and any of
                          its features, functionalities, interfaces, and
                          services will meet User/Member’s requirements or
                          expectations;
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">v. </span> errors or
                          defects will be corrected; or
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">vi. </span> the Services
                          and/or activities under eHealth, and any of its
                          features, functionalities, interfaces, and services,
                          as well as the platform, systems and servers that make
                          the Services and/or activities under eHealth, and any
                          of its features, functionalities, interfaces, and
                          services available are free of viruses or other
                          harmful components.
                        </div>

                        <div className="text-xs text-justify ml-4 mt-2">
                          The Services and/or activities under eHealth, or any
                          of its features, functionalities, interfaces, and
                          services, and all contents are provided to the
                          User/Member strictly on an "as is" basis. All
                          conditions, representations and warranties, whether
                          express or implied (such as but not limited to any
                          implied warranties as to fitness for any particular
                          purpose, or non-infringement of third party rights),
                          are hereby disclaimed by Maxicare and by the Third
                          Party-Owner and their licensors, if applicable, to the
                          maximum extent permitted by law.
                        </div>
                      </div>

                      <div>
                        <div className="text-xs text-justify ml-4 mt-2">
                          <span className="font-bold">b. </span> Maxicare shall
                          not be liable for any loss or damage of whatever
                          nature in connection with the implementation of
                          transactions covered by these T&Cs in the following
                          instances:
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">i. </span> Disruption,
                          failure or delay which are due to circumstances beyond
                          the control of Maxicare, fortuitous events such as but
                          not limited to prolonged power outages, breakdown in
                          computers and communication facilities, typhoons,
                          public disturbances and calamities, and other similar
                          or related cases;
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">ii. </span> Loss or damage
                          that User/Member may suffer due to theft or
                          unauthorized use of the Member/User Account’s
                          passwords, personal data, or violation of other
                          security measures with or without the User/Member
                          Account’s participation; and
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">iii. </span> Inaccurate,
                          incomplete or delayed information received by the
                          User/Member due to disruption or failure of any
                          communication facilities.
                        </div>
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">c. </span> Limitation of
                        Liability. In no event shall Maxicare and the
                        Third-Party Owner's aggregate liability exceed the
                        amount actually paid by and/or due from the User/Member
                        in the twelve (12) month period immediately preceding
                        the event giving rise to such claim. In no event shall
                        Maxicare and the Third-Party Owner and/or their
                        licensors be liable to anyone for any indirect,
                        punitive, special, exemplary or other damages of any
                        type (due to loss of data) arising out of or in
                        connection with the Services, the App, including any of
                        its features, functionalities, interfaces, services and
                        the Contents including the use or inability to use the
                        App, or for any content obtained from or through the
                        App, any interruption, inaccuracy, error or omission,
                        regardless of any cause, even if Maxicare and the
                        Third-Party Owner or their licensors have been
                        previously advised of the possibility of such damages.
                      </div>
                    </div>

                    <div className="mt-2">
                      <div className="text-xs font-bold">
                        5. Renewal, Suspension, and Termination
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">a.</span> Billing and
                        Renewal shall be governed by the terms and conditions
                        set forth in the relevant Agreements.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">b.</span> Non-Payment and
                        Suspension. In addition to any other rights granted to
                        Maxicare and the Third-Party Owner herein, Maxicare and
                        the Third-Party Owner reserve the right to suspend or
                        terminate these T&Cs and the User/Member’s access to the
                        Services and/or activities under eHealth.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">c.</span> Maxicare and the
                        Third-Party Owner reserve the right to impose a
                        reconnection fee in the event the User/Member or
                        Company’s account with Maxicare is suspended and
                        thereafter of request for access to the Services and/or
                        activities under eHealth is made. The User/Member agrees
                        and acknowledges that Maxicare and the Third-Party Owner
                        shall have no obligation to retain User/Member Data and
                        that such User/Member Data may be irretrievably deleted
                        if the User or the Prospective Employee is delinquent.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">d.</span> Term. These T&Cs
                        shall commence once the User/Member clicks the "accept"
                        button of these T&Cs and be coterminous with the
                        Agreements with the User/Member. After the termination
                        of these T&Cs, the User/Member agrees and acknowledges
                        that Maxicare and the Third-Party Owner have no
                        obligation to retain the User/Member Data, and may
                        delete such User/Member Data upon expiration or
                        termination of these T&Cs for whatever cause.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">e.</span> Termination for
                        Cause. Any breach of the User/Member and/or the
                        Company’s payment obligations and/or unauthorized use of
                        the Services and/or activities under eHealth shall be
                        deemed by Maxicare and by the Third-Party Owner as a
                        material breach. In this regard, Maxicare and their
                        Third-Party Owner, in their sole discretion, may
                        terminate the use of the Services and/or activities
                        under eHealth in view of any breach and/or User/Member
                        failure to comply with these T&Cs or the relevant
                        contracts and agreements. In addition, Maxicare and the
                        Third-Party Owner may terminate a free account at any
                        time in their sole discretion.
                      </div>
                    </div>

                    <div className="mt-2">
                      <div className="text-xs font-bold">6. Notice</div>

                      <div>
                        <div className="text-xs text-justify ml-4 mt-2">
                          Maxicare and the Third-Party Owner may give notice by
                          any of the following means
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">i.</span> general notice
                          in the Services and/or activities under eHealth,
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">ii.</span> electronic mail
                          to User/Member’s e-mail address as recorded in
                          Maxicare and the Third-Party Owner's account
                          information, or
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">iii.</span> by written
                          communication sent by first class mail or pre-paid
                          post to the User/Member’s address on record in
                          Maxicare and Third-Party Owner's account information.
                        </div>

                        <div className="text-xs text-justify ml-10 mt-2">
                          <span className="font-bold">iv.</span> calls or SMS to
                          User/ Member as recorded in Maxicare and Third-Party
                          Owner’s account information.
                        </div>
                      </div>
                    </div>

                    <div className="mt-2">
                      <div className="text-xs font-bold">
                        7. Miscellaneous Provisions
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">a.</span> Amendments.
                        Maxicare and the Third-Party Owner reserve the right to
                        modify these T&Cs or their policies relating to the
                        Services and/or activities under eHealth at any time,
                        effective upon posting of an updated version of the
                        T&Cs. The User/Member shall be responsible for regularly
                        reviewing the T&Cs and if it's amendment or
                        modification. Continued use of the App, participation in
                        or availment of any of the Services or eHealth, after
                        any such changes shall constitute the User/Member’s and
                        his Account’s consent to such changes.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">b.</span>
                        <span className="italic">
                          Attorney’s Fees and Cost of Litigation{/* */}
                        </span>
                        {/* */}
                        In the event of any legal action or other proceeding
                        brought to enforce the Agreement and these T&Cs,
                        Maxicare shall be entitled to reasonable attorney’s fees
                        and other costs incurred during that proceeding in
                        addition to any other relief to which it is entitled.
                        Maxicare shall be entitled to collect Two Hundred
                        Thousand Pesos (P200,000.00) as minimum damages, in
                        addition to any other damages which it may be entitled
                        under the Agreement and under the law, and attorney's
                        fees in the minimum amount of One Hundred Thousand Pesos
                        (P100,000.00) in the event that it shall be constrained
                        to engage the services of counsel to prosecute its
                        claim.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">c.</span> Governing Law and
                        Venue. These T&Cs shall be governed by the laws of the
                        Republic of the Philippines, without regard to the
                        choice or conflicts of law provisions of any
                        jurisdiction, and any disputes, actions, claims or
                        causes of action arising out of or in connection with
                        these T&Cs, the relevant contracts and agreements or the
                        Services shall be subject to the exclusive jurisdiction
                        of the proper courts of Makati City, to the exclusion of
                        other courts.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">d.</span> Unenforceable
                        Provisions. If any provision of these T&Cs is held by a
                        court of competent jurisdiction to be invalid or
                        unenforceable, then such provision(s) shall be
                        construed, as nearly as possible, to reflect the
                        intentions of the invalid or unenforceable provision(s),
                        with all other provisions remaining in full force and
                        effect.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">e.</span> Failure to
                        Enforce. The failure of Maxicare and Third-Party Owners
                        to enforce any right or provision in these T&Cs shall
                        not constitute a waiver of such right or provision
                        unless acknowledged and agreed to by Maxicare and
                        Third-Party Owners in writing.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">f.</span> Relationship. No
                        joint venture, partnership, employment, or agency
                        relationship exists between the User/Member and
                        Maxicare, as well as between Maxicare and the
                        Third-Party Owner as a result of these T&Cs or use of
                        the App.
                      </div>

                      <div className="text-xs text-justify ml-4 mt-2">
                        <span className="font-bold">g.</span> Complete
                        Agreement. These T&Cs and the relevant contracts and
                        agreements comprise the entire agreement between the
                        User/Member and Maxicare, as well as between User/Member
                        and Third-Party Owner (thru Maxicare), and supersede all
                        prior or contemporaneous negotiations, discussions or
                        agreements, whether written or oral, between the parties
                        regarding the subject matter contained herein.
                      </div>
                    </div>

                    <div className="text-[0.55rem] mt-4">
                      * The Terms and Conditions are subject to change.
                      Users/Member may address any queries related to these T&Cs
                      to{/* */}
                      <a
                        className="font-bold text-[#0947AB]"
                        target="_blank"
                        rel="noreferrer"
                        href="mailto:dpo@maxicare.com.ph"
                      >
                        dpo@maxicare.com.ph
                      </a>
                      {/* */}.
                    </div>

                    <div className="text-[0.50rem] grid justify-items-end mt-4">
                      Form Template Control: Data Privacy Office/August 22,
                      2024/FO-DPO-0.110/Rev.03
                    </div>
                  </div>
                </div>

                <div className="p-4">
                  <div className="flex flex-row items-center justify-center">
                    <div>
                      <NavigateBeforeIcon
                        fontSize="large"
                        sx={{
                          color: "#EBEBE4",
                          cursor: "pointer",
                        }}
                      />
                    </div>

                    <div className="">1</div>

                    <div>
                      <NavigateNextIcon
                        fontSize="large"
                        sx={{
                          color: "#A3A7AB",
                          cursor: "pointer",
                        }}
                        onClick={() => toggleModal("privacy")}
                      />
                    </div>
                  </div>
                  <div>
                    <Button
                      className="w-full text-[#A3A7AB] bg-[#F6F7F7]"
                      disabled={true}
                    >
                      I agree
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

TermsConditionsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  toggleModal: PropTypes.any,
};
export default TermsConditionsModal;
